// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import styles from './styles.module.scss';

type Props = {
  headerId: string,
  subHeaderId: string,
  values?: Object,
  alignCenter?: boolean,
  headerVariant?: 'd2' | 'd3',
};

const PageHeader = ({ headerId, subHeaderId, values, alignCenter, headerVariant }: Props) => {
  if (!headerId || !subHeaderId) return null;

  return (
    <div className={classNames(styles.container, { [styles.alignCenter]: alignCenter })}>
      <div className={classNames(styles.header, { [styles.headerD2]: headerVariant === 'd2' })}>
        <FormattedMessage id={headerId} values={values} />
      </div>
      <div className={styles.subHeader}>
        <FormattedMessage id={subHeaderId} values={values} />
      </div>
    </div>
  );
};

export default PageHeader;
